import { useQuery } from "@pathwright/features/src/modules/utils/apollo"
import gql from "graphql-tag"
import { GroupFragmentDoc } from "@pathwright/graphql-client/src/generated"

export const COHORT_QUERY = gql`
  query GroupQuery($id: Int!) {
    cohort: group(id: $id) {
      ...Group
    }
  }
  ${GroupFragmentDoc}
`

const useCohortQuery = ({ cohortId }) => {
  const cohortQuery = useQuery(COHORT_QUERY, {
    variables: {
      id: cohortId
    },
    skip: !cohortId
  })

  return cohortQuery
}

export default useCohortQuery
